<template>
	<div id="leftinfo">
		<span style="color: aliceblue;font-weight: bold;font-size: 30px;"><el-avatar :size="60" src="http://itbx.cc/favicon.ico"></el-avatar><p style="float:right;padding-top: 5px;">下载国度后台管理系统</p></span>
		<el-menu
			default-active="1-1"
			class="el-menu-vertical-demo"
			background-color="#545c64"
			text-color="#fff"
			active-text-color="#ffd04b">
			<el-submenu index="1">
				<template slot="title">
					<i class="el-icon-location"></i>
					<span>功能列表</span>
				</template>
				<el-menu-item-group>
					<template slot="title">选项</template>
					<el-menu-item index="1-1"><router-link to="/User/create" tag="li">投稿</router-link></el-menu-item>
					<el-menu-item index="1-2"><router-link to="/User/sele" tag="li">查询</router-link></el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			
		</el-menu>
	</div>
</template>

<script>
	export default{
		name:'leftinfo',
		data(){
			return{
				drawer: true,
			}
		},
	}
</script>

<style scoped>
	#leftinfo{
		padding: 5px;
		height: 100vh;
		background-color:#545c64 ;
		width: 370px;
		float: left;
	}
</style>